var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { options, pathAttrs, borderOptions, getUnit, getNumber } from './borderUtils';
import StyleConfTemplate from '../StyleConfTemplate';
import SizeInput from '../widgets/sizeInput';
import ColorPicker from "../../../../../../lib/builtin/components/ColorPicker/index";
import { COLOR_PICKER_INIT_VALUE } from '../../utils/constant';
let BorderBox = class BorderBox extends Vue {
  constructor() {
    super(...arguments);
    this.borderStyleOption = [{
      value: 'solid',
      label: '实线'
    }, {
      value: 'dotted',
      label: '点线'
    }, {
      value: 'dashed',
      label: '虚线'
    }, {
      value: 'double',
      label: '双线'
    }];
    this.selectedBorder = 'border';
  }
  get currBorderInfo() {
    return {
      color: !this.borderFieldSetColors[`${this.selectedBorder}Color`] ? this.borderFieldSetColors.borderColor || COLOR_PICKER_INIT_VALUE : this.borderFieldSetColors[`${this.selectedBorder}Color`],
      style: !this.borderFieldSetStyles[`${this.selectedBorder}Style`] ? this.borderFieldSetStyles.borderStyle || '' : this.borderFieldSetStyles[`${this.selectedBorder}Style`],
      width: !this.borderFieldSetWidths[`${this.selectedBorder}Width`] ? this.borderFieldSetWidths.borderWidth || 0 : this.borderFieldSetWidths[`${this.selectedBorder}Width`]
    };
  }
  get currBorderWidth() {
    return {
      unit: getUnit(this.currBorderInfo.width),
      value: getNumber(this.currBorderInfo.width)
    };
  }
  borderWidthChange(val) {
    if (typeof val === 'string' || val === null) this.emitChange('Width', val);else this.emitChange('Width', `${val}${this.currBorderWidth.unit}`);
  }
  emitChange(tag, val) {
    if (this.selectedBorder !== 'none') {
      this.$emit('change', [`${this.selectedBorder}${tag}`, val, this.selectedBorder]);
    }
  }
  render() {
    const h = arguments[0];
    return h(StyleConfTemplate, {
      "attrs": {
        "name": "边框"
      }
    }, [h("div", {
      "class": "uc-stylePanel-border-box-wrapper"
    }, [h("div", {
      "class": "uc-stylePanel-border-box"
    }, [options.map(option => h("div", {
      "class": ['uc-stylePanel-border-box-option', `${option.title}`, `${option.title === this.selectedBorder ? 'selected' : ''}`],
      "style": {
        gridArea: option.title
      },
      "on": {
        "click": () => this.selectedBorder = this.selectedBorder === option.title ? 'none' : option.title
      }
    }, [h("svg", {
      "attrs": {
        ...borderOptions
      }
    }, [h("path", {
      "attrs": {
        "d": option.out,
        ...pathAttrs
      }
    }), option.title !== 'border' && h("path", {
      "attrs": {
        "d": option.in
      }
    })])]))]), h("div", {
      "style": "width: 100%; margin-left: 10px;"
    }, [h(StyleConfTemplate, {
      "attrs": {
        "name": "样式",
        "changed": '' !== this.currBorderInfo.style,
        "inline": true
      },
      "on": {
        "reset": () => this.emitChange('Style', null)
      }
    }, [h("a-radio-group", {
      "attrs": {
        "value": this.currBorderInfo.style,
        "button-style": "solid"
      },
      "on": {
        "change": e => this.emitChange('Style', e.target.value)
      }
    }, [this.borderStyleOption.map(option => h("a-tooltip", [h("div", {
      "slot": "title"
    }, [" ", option.value, " "]), h("a-radio-button", {
      "attrs": {
        "value": option.value
      }
    }, [h("div", {
      "style": {
        width: '20px',
        height: '55%',
        borderBottom: `${option.value} ${option.value === 'double' ? '4px' : '2px'}`
      }
    })])]))])]), h(StyleConfTemplate, {
      "attrs": {
        "name": "宽度",
        "changed": this.currBorderWidth.value !== '0',
        "inline": true
      },
      "on": {
        "reset": () => this.borderWidthChange(null)
      }
    }, [h("div", {
      "class": "uc-stylePanel-inline-content"
    }, [h("a-slider", {
      "class": "uc-stylePanel-inline-slider",
      "attrs": {
        "min": 0,
        "max": 20,
        "value": Math.min(20, +this.currBorderWidth.value)
      },
      "on": {
        "change": this.borderWidthChange
      }
    }), h(SizeInput, {
      "class": "uc-stylePanel-inline-input",
      "attrs": {
        "unit": this.currBorderWidth.unit,
        "placeholder": "4",
        "value": `${this.currBorderWidth.value}`
      },
      "on": {
        "change": this.borderWidthChange
      }
    })])]), h(StyleConfTemplate, {
      "attrs": {
        "name": "颜色",
        "changed": this.currBorderInfo.color !== COLOR_PICKER_INIT_VALUE,
        "inline": true
      },
      "on": {
        "reset": () => this.emitChange('Color', null)
      }
    }, [h("div", {
      "class": "uc-stylePanel-inline-content"
    }, [h("color-picker", {
      "attrs": {
        "placement": "topRight",
        "value": this.currBorderInfo.color || COLOR_PICKER_INIT_VALUE
      },
      "on": {
        "change": val => this.emitChange('Color', val)
      }
    })])])])])]);
  }
};
__decorate([Prop({
  required: true,
  type: Object
})], BorderBox.prototype, "borderFieldSetColors", void 0);
__decorate([Prop({
  required: true,
  type: Object
})], BorderBox.prototype, "borderFieldSetStyles", void 0);
__decorate([Prop({
  required: true,
  type: Object
})], BorderBox.prototype, "borderFieldSetWidths", void 0);
BorderBox = __decorate([Component({
  name: 'BorderBox',
  components: {
    ColorPicker
  }
})], BorderBox);
export default BorderBox;
//# sourceMappingURL=borderBox.js.map
